class MarketoHelper {
  run() {
    this.copy_pdf_url_to_marketo_form();
    this.handle_download_pdf_link_click();
    this.handle_marketo_form_submission();
  }

  copy_pdf_url_to_marketo_form() {
    const marketo = this.get_marketo();

    if (marketo !== null) {
      const input_name = $('#cta-form-field-for-pdf').val();
      marketo.whenReady(() => $(`input[name="${input_name}"]`).val($('#prospect-pdf-url').val()));
    }
  }

  handle_download_pdf_link_click() {
    $('body').on('click', '#download-pdf-link', (event) => {
      event.preventDefault();

      if (this.get_marketo()) {
        $('#download-modal').modal('show');
      } else { // we're in the test env or the user has an ad blocker
        $('#sent-prospect-email').val('true');
        $('#calculator-form').submit();
        $('#ad-blocker-modal').modal();

        $.ajax({
          url: '/ad_block_logs',
          type: 'POST',
          beforeSend(xhr) { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')); },
          data: `cvm_session_id=${$('#cvm-session-id').val()}&calculator_id=${$('#calculator-id').val()}`
        });
      }
    });
  }

  get_marketo() {
    /* eslint-disable no-undef */
    if (typeof MktoForms2 !== 'undefined' && MktoForms2 !== null) {
      return MktoForms2;
    }
    /* eslint-enable no-undef */

    return null;
  }

  handle_marketo_form_submission() {
    const that = this;
    $('body').on('click', '.mktoButton', function() {
      if (that.check_required_marketo_fields($(this)) !== false) {
        that.update_status_and_submit_calculator();
        that.close_form_modal($(this));
        that.show_thanks_modal($(this));
        that.open_pdf($(this));
      }
    });

    this.close_thanks_modal();
  }

  check_required_marketo_fields($marketo_button) {
    const missing_required = $marketo_button.closest('form').find('.mktoRequired').filter(function() {
      if ($(this).hasClass('mktoLogicalField')) {
        return $(this).find('.mktoField').is(':not(:checked)');
      }

      return $(this).val().length === 0;
    });

    if (missing_required.length > 0) {
      return false;
    }
    return true;
  }

  update_status_and_submit_calculator() {
    $('#sent-prospect-email').val('true');
    $('#calculator-form').submit();
  }

  close_form_modal($marketo_button) {
    $($marketo_button.closest('.modal')).modal('toggle');
  }

  show_thanks_modal($marketo_button) {
    $marketo_button.closest('.modal-body').find('.modal-after-submit-js').collapse('show');
  }

  open_pdf($marketo_button) {
    if ($marketo_button.closest('.modal').attr('id') === 'download-modal') {
      window.open($('#prospect-pdf-url').val(), '_pdf');
    }
  }

  close_thanks_modal() {
    $('body').on('click', '.modal-after-submit-js .btn', function() {
      return $(this).closest('.modal').modal('hide');
    });
  }
}

export default MarketoHelper;
